import React from 'react';
import ReactDOM from 'react-dom';
//import Root from "src/components/Root";
import App from "src/App";
import { Provider } from "react-redux";
import {configureStore} from "src/store.js";

import { BrowserRouter } from 'react-router-dom';

const state = window.__INITIAL_STATE__;
delete window.__INITIAL_STATE__;
const store = configureStore(state);

//console.log( 'Root mobile: ' + state.isMobile )

ReactDOM.hydrate(
	<BrowserRouter>
		<Provider store={store}>
    		<App />
    	</Provider>
	</BrowserRouter>,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js